// extracted by mini-css-extract-plugin
export default {"supplierTextFieldWrapper":"address-fields_supplierTextFieldWrapper__lmV3M"};